package com.starparty.app.astro0.events

import com.starparty.app.astro0.Controls
import com.starparty.app.astro0.SP_Canvas
import com.starparty.app.astro0.Searchable
import com.starparty.app.astro0.Sky
import com.starparty.app.astro0.SkyView
import com.starparty.app.geometry.SP_Point


class SearchHandler(var sky: Sky, var skyView: SkyView, var controls: Controls) {

    val maxSuggestions = 6
    var searchableItemsList: ArrayList<Searchable>
    var latestSearchText = ""

    init {

        searchableItemsList = ArrayList()

        var orreryBodies = sky.orrery.bodies

        for (b in orreryBodies) {
            searchableItemsList.add(b)
        }

        var constellations = sky.starField.constellations

        for (c in constellations) {
            searchableItemsList.add(c)
        }

        var dsos = sky.deepSkyField.dsos

        for (d in dsos) {
            searchableItemsList.add(d)
        }

        var stars = sky.starField.stars

        for (s in stars) {
            if (s.name != "") {
                searchableItemsList.add(s)
            }
        }
    }

    fun getSuggestions(searchString: String): Array<Searchable>? {

        var exactMatches = emptyArray<Searchable>()
        var startsWithWordMatches = emptyArray<Searchable>()
        var startsWithMatches = emptyArray<Searchable>()
        var partialMatches = emptyArray<Searchable>()
        var suggestions = emptyArray<Searchable>()
        val processedSearchString = searchString.trim().lowercase()

        if (processedSearchString == "") {
            return suggestions
        }

        for (i in searchableItemsList) {

            val name = i.getSearchableName().lowercase()

            if (name == processedSearchString) {
                exactMatches += i
            }
            else if (name.startsWith("$processedSearchString ")) {
                startsWithWordMatches += i
            }
            else if (name.startsWith(processedSearchString)) {
                startsWithMatches += i
            }
            else if (name.contains(processedSearchString)) {
                partialMatches += i
            }
        }

        suggestions = exactMatches + startsWithWordMatches + startsWithMatches + partialMatches

        if (suggestions.size > maxSuggestions){
            suggestions = suggestions.copyOfRange(0, maxSuggestions)
        }

        return suggestions
    }

    fun textSubmit(fullQuery: String): Boolean {

        val queryName = fullQuery.substringBefore('(')

        val suggestions = getSuggestions(queryName)
        if (suggestions != null){
            if (suggestions.size > 0) {
                val topSuggestion = suggestions[0]
                controls.stopTrackingSenorOrientation()
                centreObjectOnScreen(topSuggestion)
            }
        }

        return true
    }

    fun centreObjectOnScreen(i: Searchable){

        sky.setAltAzmCoordinatesWithZenithUp(0.0, 0.0)

        val x = skyView.getCanvas().getCentreX()
        val y = skyView.getCanvas().getCentreY()
        val viewCentrePoint = SP_Point(x,y)

        val equCentreCoords = sky.getEquatorialCoordinates(viewCentrePoint)
        val equCoordsOfObject = i.getEquatorialCoordinates()

        val altAzObject = sky.coordinateTransformer.EquSphericalToAltAzmSpherical(equCoordsOfObject.rA, equCoordsOfObject.dec)
        val altAzCentre = sky.coordinateTransformer.EquSphericalToAltAzmSpherical(equCentreCoords.rA, equCentreCoords.dec)

        val altDifference = altAzCentre.alt - altAzObject.alt

        sky.coordinateTransformer.incrementAlt(-altDifference)
        sky.coordinateTransformer.incrementAzm(-altAzObject.azm)

    }

}

